import { useState, useEffect } from "react";
import {
  backgroundLight,
  textPrimary,
  textSecondary,
  white,
} from "../../../../../utils/colors";
import FormControlTextArea from "../../../../../components/input/FormControlTextArea";
import { Box, Button, Flex, Icon, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaPlus } from "react-icons/fa6";
import { TbEdit } from "react-icons/tb";

const TreatmentPlanPatientNotes = ({ notes, draftNote, setDraftNote }) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    setDraftNote(notes || "");
  }, [notes]); // sync when parent note changes

  // console.log("notes", notes);

  return (
    <>
      <Box m="2rem 0 0" direction="column">
        <Flex
          align="center"
          justify="space-between"
          p={["0.5rem 1.5rem", "0.5rem 0"]}
        >
          <Text fontSize="0.875rem" fontWeight="600" color={textPrimary}>
            {t("treatmentPlan.tpNotesPatient")}
          </Text>
          <Flex align="center" justify="flex-end" gap="0.5rem">
            {open && (
              <Button
                size="sm"
                fontSize="0.8rem"
                //   bg={white}
                bg={backgroundLight}
                color={textSecondary}
                borderRadius="10rem"
                onClick={() => {
                  setOpen(!open);
                  setDraftNote(notes || "");
                }}
              >
                <Text fontSize="0.875rem" fontWeight="500">
                  {t("button.cancel")}
                </Text>
              </Button>
            )}

            {notes ? (
              <Button
                size="sm"
                fontSize="0.8rem"
                //   bg={white}
                bg={backgroundLight}
                color={textSecondary}
                borderRadius="10rem"
                onClick={() => {
                  setOpen(!open);
                }}
              >
                <Icon
                  as={TbEdit}
                  fontSize="0.9rem"
                  fontWeight="400"
                  mr="0.25rem"
                />
                <Text fontSize="0.875rem" fontWeight="500">
                  {t("treatmentPlan.editTpNotePatient")}
                </Text>
              </Button>
            ) : (
              <Button
                size="sm"
                fontSize="0.8rem"
                //   bg={white}
                bg={backgroundLight}
                color={textSecondary}
                borderRadius="10rem"
                onClick={() => {
                  setOpen(!open);
                  //   setNotes("");
                }}
              >
                <Icon
                  as={FaPlus}
                  fontSize="0.75rem"
                  fontWeight="400"
                  mr="0.25rem"
                />
                <Text fontSize="0.875rem" fontWeight="500">
                  {t("treatmentPlan.addTpNotePatient")}
                </Text>
              </Button>
            )}
          </Flex>
        </Flex>

        <Box
          w="100%"
          bg={backgroundLight}
          // border={`1px solid ${newBorder}`}
          p={["0rem", "1rem"]}
          borderRadius={["0rem", "1rem"]}
        >
          <Box w="100%" p={["1.5rem", "initial"]}>
            {!open ? (
              <>
                {!notes ? (
                  <Text
                    fontSize="0.8rem"
                    fontWeight="500"
                    color={textSecondary}
                  >
                    {t("treatmentPlan.tpNotesPatientEmpty")}
                  </Text>
                ) : (
                  <Flex w="100%" bg={white} p="1rem" borderRadius="1rem">
                    <Text
                      fontSize="0.8rem"
                      fontWeight="500"
                      color={textSecondary}
                    >
                      {notes}
                    </Text>
                  </Flex>
                )}
              </>
            ) : (
              <FormControlTextArea
                label={t("form.notes")}
                value={draftNote}
                placeholder={t("placeholder.tpNotesPatient")}
                onChange={(e) => {
                  setDraftNote(e.target.value);
                }}
                fontSize={["md", "sm"]}
                w="100%"
                h="initial"
                minH="100px"
                mb="0"
              />
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default TreatmentPlanPatientNotes;
